export function getEnvCountryFromStorage(): string {
  try {
    const wkey = JSON.parse(localStorage.getItem('writeKey') || '""') || '';
    return wkey;
  } catch (_: any) {
    return '';
  }
}
